module.exports = require("./lib/_stream_duplex.js")



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/duplex.js
// module id = 594
// module chunks = 0 1